import { render, staticRenderFns } from "./PropertyCreate.vue?vue&type=template&id=1bd31d67&"
import script from "./PropertyCreate.vue?vue&type=script&lang=js&"
export * from "./PropertyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports